module["exports"] = ["საქართველო"];